import _ from "lodash";
import { itemFields } from "../../../../constants/fields.constant";
import { calculateSaleAmount } from "../../../../util/calculations/sale-amount";

export const materialToForm = (_material, { qty = 1, profitMargin = 1, profitMarginType = 'PERCENTAGE' }) => {
    if (!_.isObject(_material)) _material = JSON.parse(_material);

    const item = _.cloneDeep(itemFields)
    item.name.value = _material.item;
    item.taskId.value = _material.taskId || null;
    item.id = _material.id;
    item.manufacturer = _material.manufacturer;
    item.partNo = _material.partNo || _material.part_no;
    item.categoryId = _material.categoryId;
    item.costPerItem.value = _material.cost;
    item.saleAmount.value = calculateSaleAmount({
        cost: _material.cost,
        profitMargin,
        profitMarginType,
    });
    item.saleAmountLock.value = true;
    item.unit.value = _material.unit || null;
    item.qty.value = (_material.qty * qty) || 1;
    item.total.value = item.saleAmount.value * item.qty.value;

    return item;
}

export const updateMaterialSubTask = (subTask, templateMaterials, itemToUpdate) => {
    return subTask.material.map((material, index) => {
        const templateMaterial = templateMaterials.find(tempMaterial => tempMaterial.id === material.id);
        const templateMaterialQty = templateMaterial ? Number(templateMaterial.qty) : '';
        if (templateMaterialQty) {
            return {
                ...material,
                qty: {
                    ...material.qty,
                    value: (Number(itemToUpdate.templateQuantity) * Number(templateMaterialQty))
                },
                total: {
                    ...material.total,
                    value: (Number(itemToUpdate.templateQuantity) * Number(templateMaterialQty) * Number(material.saleAmount.value))
                }
            };
        } else return material;
    });
}

